"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const hooks_1 = require("preact/hooks");
function usePagination(init) {
    const { initialPage, itemsPerPage, itemsCount } = init;
    const maxPage = Math.max(1, Math.ceil(itemsCount / itemsPerPage));
    const [currentPage, setCurrentPage] = (0, hooks_1.useState)(initialPage);
    const paginate = (0, hooks_1.useCallback)((items) => {
        const startIndex = (currentPage - 1) * itemsPerPage;
        const endIndex = startIndex + itemsPerPage;
        return items.slice(startIndex, endIndex);
    }, [currentPage, itemsPerPage]);
    (0, hooks_1.useEffect)(() => {
        setCurrentPage(1);
    }, [itemsCount]);
    (0, hooks_1.useEffect)(() => {
        history.replaceState({ page: currentPage }, '', location.pathname);
    }, []);
    (0, hooks_1.useEffect)(() => {
        const handlePopState = (event) => {
            const { page } = event.state;
            if (typeof page === 'number') {
                setCurrentPage(page);
            }
        };
        addEventListener('popstate', handlePopState);
        return () => {
            removeEventListener('popstate', handlePopState);
        };
    }, []);
    return Object.assign({ paginate,
        maxPage,
        currentPage,
        setCurrentPage }, init);
}
exports.default = usePagination;
